<script>
  import Text from '@components/general/text.svelte'
  import { cn } from '@lib/utils'

  let { title, children, class: className, ...restProps } = $props()
</script>

<div class={cn('flex flex-col gap-3', className)} {...restProps}>
  {#if title}
    <Text variant="section_title" text={title} as="h5" class="mb-3" />
  {/if}
  {@render children?.()}
</div>